 import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

export interface ValidationErrorResponse {
  status: "error";
  message: string;
  expected_columns: string[];
  uploaded_columns: string[];
  mismatches: {
    position: number;
    expected: string;
    actual: string;
  }[];
}

interface sortObj {
  heading: string;
  sortType: string;
  // secondarySort?: { heading: string; sortType: string };
}

export interface ASAPdata {
  columns: string[];
  values: any[];
  offset: number;
  limit: number;
  total_pages: number;
  page: number;
  hasMore: boolean;
}

interface OptionType {
  value: string;
  label: string;
}

interface ASAPDataState {
  Asapdata: ASAPdata | null | any;
  loading: boolean;
  error: null | any;
  offset: any;
  ValidationOfFileasap: any;
  validationError: ValidationErrorResponse | null | any;
  validationStatus: "idle" | "loading" | "success" | "error" | any;
  uploadFileDataASAP: number[] | string[];
  asapColumns: any;
  asapRows: any;
  ValidationLoading: boolean;
  message: string;
  hasMore: boolean;
  currentPageASAP: number;
  uploadFileData: any;
  isSubmitDisabledForPreview: boolean;
  kddDataWithPagination: any;
  isUploading: boolean;
  titleSortBy: sortObj;
  detail: any;
  DateOption: any;
  kddTitleOption: any;
  filenameOptions: any;
  selectedMarketingList?: OptionType[];
  selectedAsapTitleList?: OptionType[];
  selectedAsapFilename?: OptionType[];
  columnsSort: any;
  PreviewExistingPopupOpen: boolean;
  sortState?: sortObj;
  filename: any;
  scrolling: boolean;
  GetKddIconData: any;
  limit: number;
  status: number;
  totalItems: any;
  asapLoading: boolean;
}

const initialState: ASAPDataState = {
  Asapdata: null,
  loading: false,
  status: 0,
  error: null,
  ValidationOfFileasap: "",
  validationError: null,
  validationStatus: "idle",
  uploadFileDataASAP: [],
  asapColumns: [],
  asapRows: [],
  message: "",
  ValidationLoading: false,
  hasMore: false,
  currentPageASAP: 1,
  uploadFileData: [],
  isSubmitDisabledForPreview: false,
  kddDataWithPagination: [],
  offset: 0,
  limit: 10,
  totalItems: 10,
  isUploading: false,
  titleSortBy: {
    heading: "",
    sortType: "asc",
  },
  detail: "",
  DateOption: [],
  kddTitleOption: [],
  filenameOptions: [],
  selectedMarketingList: [],
  selectedAsapTitleList: [],
  selectedAsapFilename: [],
  columnsSort: {},
  PreviewExistingPopupOpen: false,
  sortState: {
     heading: "PRIMARY_ASIN",
    sortType: "desc",
  },
  filename: "",
  scrolling: false,
  GetKddIconData: [],
  asapLoading: false,
};

// Client-side sorting function
// const sortData = (
//   data: any[],
//   columns: string[],
//   heading: string,
//   sortType: string,
//   secondarySort?: { heading: string; sortType: string }
// ) => {
//   const primaryIndex = columns.indexOf(heading);
//   const secondaryIndex = secondarySort ? columns.indexOf(secondarySort.heading) : -1;

//   if (primaryIndex === -1) {
//     console.warn(`Primary column ${heading} not found in columns`);
//     return data;
//   }

//   return [...data].sort((a, b) => {
//     const aPrimary = a[primaryIndex] ?? "";
//     const bPrimary = b[primaryIndex] ?? "";
//     let comparison = 0;

//     // Compare primary column
//     if (typeof aPrimary === "string" && typeof bPrimary === "string") {
//       comparison = aPrimary.localeCompare(bPrimary, undefined, { numeric: true });
//     } else {
//       comparison = aPrimary < bPrimary ? -1 : aPrimary > bPrimary ? 1 : 0;
//     }

//     // Reverse for descending order
//     if (sortType === "desc") {
//       comparison = -comparison;
//     }

//     // If primary values are equal and secondary sort is defined, compare secondary column
//     if (comparison === 0 && secondaryIndex !== -1 && secondarySort) {
//       const aSecondary = a[secondaryIndex] ?? "";
//       const bSecondary = b[secondaryIndex] ?? "";
//       let secondaryComparison = 0;

//       if (typeof aSecondary === "string" && typeof bSecondary === "string") {
//         secondaryComparison = aSecondary.localeCompare(bSecondary, undefined, { numeric: true });
//       } else {
//         secondaryComparison = aSecondary < bSecondary ? -1 : aSecondary > bSecondary ? 1 : 0;
//       }

//       if (secondarySort.sortType === "desc") {
//         secondaryComparison = -secondaryComparison;
//       }

//       return secondaryComparison;
//     }

//     return comparison;
//   });
// };

// To upload file in ASAP
export const uploadFileASAP = createAsyncThunk(
  "asap/uploadFile",
  async (formData: FormData, thunkAPI) => {
    try {
      const response = await axios.post(`${API.UploadAsapFile}`, formData);
      console.log(response, "response");
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || "Upload failed");
    }
  }
);

// Fetch ASAP data with pagination
export const fetchASAPDataPagination = createAsyncThunk<
  ASAPdata,
  {
    page?: number;
    limit?: number;
    heading?: string;
    sortType?: string;
    secondarySort?: { heading: string; sortType: string };
    filters?: { TITLE?: any; Marketing_Activity?: any; FILE_NAME?: any };
  }
>(
  "data/fetchASAPDataPagination",
  async (
    {
      page = 1,
      limit = 10,
      heading = "",
      sortType = "asc",
      secondarySort = { heading: "PRIMARY_ASIN", sortType: "asc" },
      filters = {},
    },
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        page,
        limit,
        heading,
        sortType,
        ...(secondarySort && { secondarySort }), // Only include if secondarySort is defined
        filters,
      };
      console.log("API request payload:", payload);
      const response = await axios.post<ASAPdata>(`${API.GetAsapData}`, payload);
      console.log("API response:", response.data);
      return response.data;
    } catch (err: any) {
      console.error("API error:", err.response?.data);
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const ASAPSlice = createSlice({
  name: "ASAPreducer",
  initialState,
  reducers: {
    setAsapColumns: (state, action) => {
      state.asapColumns = action.payload;
    },
    setAsapRows: (state, action) => {
      state.asapRows = action.payload;
    },
    clearAsapData: (state) => {
      state.Asapdata = { values: [], columns: [] };
    },
    clearValidatorErrors: (state) => {
      state.validationError = null;
      state.validationStatus = null;
    },
    setCurrentPageASAP: (state, action) => {
      console.log("currentPageinReducer is being set", action.payload);
      state.currentPageASAP = action.payload;
    },
    setIsSubmitDisabledForPreview: (state, action) => {
      state.isSubmitDisabledForPreview = action.payload;
      console.log("Set Disabled For Preview:", action.payload);
    },
    setIsUploading: (state, action) => {
      state.uploadFileData = action.payload;
    },
    titleListSortByDesc: (state, action) => {
      state.titleSortBy = action.payload;
      console.log(action.payload, "titlesortby");
    },
    setValidationError: (state, action) => {
      state.validationError = action.payload;
    },
    resetKddPagination: (state) => {
      state.Asapdata = null;
      state.currentPageASAP = 1;
      state.error = null;
    },
    resetValidationError: (state) => {
      state.validationError = null;
      state.validationStatus = "idle";
      state.ValidationLoading = false;
      state.detail = null;
    },
    resetFilterState:(state,action)=>{
state.selectedMarketingList=action.payload;
state.selectedAsapFilename=action.payload;
state.selectedAsapTitleList=action.payload;
state.sortState=initialState.sortState
    },
    updateselectedMarketingList: (state, action) => {
      state.selectedMarketingList = action.payload;
    },
    updateselectedAsapTitleList: (state, action) => {
      state.selectedAsapTitleList = action.payload;
    },
    updateselectedFileNameASAP: (state, action) => {
      state.selectedAsapFilename = action.payload;
    },
    resetSEGPage: (state) => {
      state.currentPageASAP = initialState.currentPageASAP;
    },
    setSortDirection: (
      state,
      action: PayloadAction<{ column: string; sortType: "asc" | "desc" }>
    ) => {
      const { column, sortType } = action.payload;
      state.columnsSort[column] = sortType;
    },
    setPreviewExistingPopupOpen: (state, action) => {
      state.PreviewExistingPopupOpen = action.payload;
    },
    setSortState: (state, action: PayloadAction<sortObj>) => {
      state.sortState = action.payload;
    },
    setscrolling: (state, action) => {
      state.scrolling = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearASAPState: (state) => {
      state.asapColumns = [];
      state.asapRows = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFileASAP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadFileASAP.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadFileDataASAP = action.payload;
        state.message = action.payload.message;
        console.log(action.payload, "uploadapi");
      })
      .addCase(uploadFileASAP.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchASAPDataPagination.pending, (state) => {
        state.asapLoading = true;
        state.loading = true;
        state.error = null;
      })
      // .addCase(fetchASAPDataPagination.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.asapLoading = false;
      //   state.hasMore = action.payload.hasMore;
      //   console.log("currentPageinReducer", state.currentPageASAP);

      //   let sortedValues = action.payload.values;
      //   if (state.sortState?.heading && action.payload.columns.includes("PRIMARY_ASIN")) {
      //     sortedValues = sortData(
      //       action.payload.values,
      //       action.payload.columns,
      //       state.sortState.heading,
      //       state.sortState.sortType,
      //       state.sortState.secondarySort
      //     );
      //   }

      //   if (state.currentPageASAP === 1 || !state.Asapdata) {
      //     state.Asapdata = {
      //       ...action.payload,
      //       values: sortedValues,
      //     };
      //   } else {
      //     state.Asapdata = {
      //       ...action.payload,
      //       values: [...state.Asapdata.values, ...sortedValues],
      //     };
      //   }
      //   console.log("Sorted data:", state.Asapdata.values);
      // })
        .addCase(fetchASAPDataPagination.fulfilled, (state, action) => {
        state.loading = false;
          state.asapLoading=false;
        state.hasMore = action.payload.hasMore;
        // state.currentPage = action.payload.page;
        console.log("currentPageinReducer", state.currentPageASAP);
        if (state.currentPageASAP == 1 || !state.Asapdata) {
          state.Asapdata = action.payload;
        } else {
          state.Asapdata = {
            ...action.payload,
            values: [...state.Asapdata.values, ...action.payload.values],
          };
        }
      })
      .addCase(fetchASAPDataPagination.rejected, (state, action) => {
        state.loading = false;
        state.asapLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const {
  setAsapColumns,
  setAsapRows,
  clearAsapData,
  clearValidatorErrors,
  setIsSubmitDisabledForPreview,
  setIsUploading,
  titleListSortByDesc,
  setValidationError,
  updateselectedMarketingList,
  updateselectedAsapTitleList,
  updateselectedFileNameASAP,
  setCurrentPageASAP,
  resetValidationError,
  resetKddPagination,
  resetSEGPage,
  setSortDirection,
  setPreviewExistingPopupOpen,
  setSortState,
  setscrolling,
  resetFilterState,
  setLoading,
  clearASAPState,
} = ASAPSlice.actions;

export default ASAPSlice.reducer;